module.exports = __webpack_public_path__ + "img/templestay.7f1aff9b.png";